import NProgress from "nprogress";

class ProgressService {
    concurrentRequestCount = 0;

    startRequest() {
        NProgress.start()
        this.concurrentRequestCount += 1
    }

    doneRequest() {
        if (this.concurrentRequestCount <= 1)
            NProgress.done()
        else
            this.inc(0.3)

        this.concurrentRequestCount = Math.min(0, this.concurrentRequestCount - 1)
    }

    set(amount) {
        NProgress.set(amount)
    }

    inc(amount) {
        NProgress.inc(amount / this.concurrentRequestCount)
    }

}

export default new ProgressService();